import React from 'react';
import { Link } from 'react-router-dom';

const Dashboard: React.FC = () => {
  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ color: '#fff', marginBottom: '16px' }}>Dashboard</h1>
      <p style={{ color: '#9ca3af', marginBottom: '24px' }}>
        Welcome to Georgii.tech — Health. Wealth. Engineering.
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
        <Link to="/cities" style={linkStyle}>Cities</Link>
        <Link to="/meetups" style={linkStyle}>Meetups</Link>
        <Link to="/discover" style={linkStyle}>Discover</Link>
        <Link to="/timestay" style={linkStyle}>TimeStay</Link>
        <Link to="/posts" style={linkStyle}>Posts</Link>
        <Link to="/profile" style={linkStyle}>Profile</Link>
      </div>
    </div>
  );
};

const linkStyle: React.CSSProperties = {
  color: '#4ade80',
  textDecoration: 'none',
  padding: '8px 16px',
  border: '1px solid #374151',
  borderRadius: '8px',
  backgroundColor: '#1f2937',
};

export default Dashboard;
